<template>
  <div class="box" v-if="this.info.length">
    <div class="box_top">
      <div class="click_top">
        <div class="img" @click="remove">
          <img src="https://s6.bihukankan.com/img/1681439723左.png" alt="" />
        </div>
        <span>{{ newtime }}</span>
        <div class="img" @click="add">
          <img src="https://s6.bihukankan.com/img/1681439886右.png" alt="" />
        </div>
      </div>
    </div>
    <div class="fans">
      <div class="add">
        <p>{{ $retainWan(current.fans) }}</p>
        <span>粉丝总数</span>
      </div>
      <div class="——"></div>
      <div class="add">
        <p>{{  $retainWan(current.fansDx) }}</p>
        <span>粉丝净增</span>
      </div>
    </div>
    <div id="fansadd" @click="click"></div>
  </div>
  <div v-else class="chart">
    <none-data :height="5.2" />
  </div>
</template>
<script>
export default {
  props: {
    info: { type: Array },
  },
  data() {
    return {
   max:0,
   min:0,
   current: "",
   start:0
    };
  },
  methods: {
    click() {
        // echarts 万能点击事件
   echarts.init(document.getElementById("fansadd")).getZr().on('click', params => {
    let pointInPixel = [params.offsetX, params.offsetY]
    if (echarts.init(document.getElementById("fansadd")).containPixel('grid', pointInPixel)) {
        //点击第几个柱子
        let pointInGrid = echarts.init(document.getElementById("fansadd")).convertFromPixel({ seriesIndex: 0 }, pointInPixel)
        // 也可以通过params.offsetY 来判断鼠标点击的位置是否是图表展示区里面的位置
        // 也可以通过name[xIndex] != undefined，name是x轴的坐标名称来判断是否还是点击的图表里面的内容
        // x轴数据的索引
        let xIndex = pointInGrid[0]
       this.current = this.info.sort((a, b) => a.time - b.time)[xIndex]
    }
})
    },
    // 字体适配
    FontChart(res) {
      //获取到屏幕的宽度
      var clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (!clientWidth) return; //报错拦截：
      let fontSize = 10 * (clientWidth / 1920);
      return res * fontSize;
    },
    remove() {
     const index = this.info.sort((a, b) => a.time - b.time).findIndex(((item) => item.time === this.current.time))
     if( this.info.sort((a, b) => a.time - b.time)[index - 1]) {
        this.current =  this.info.sort((a, b) => a.time - b.time)[index - 1]
     }
    },
    add() {
        const index = this.info.sort((a, b) => a.time - b.time).findIndex(((item) => item.time === this.current.time))
        if(this.info.sort((a, b) => a.time - b.time)[index + 1]) {
            this.current  =  this.info.sort((a, b) => a.time - b.time)[index + 1]
        }
    },
    time() {
        this.max = this.info.sort((a, b) => b.fans - a.fans)[0].fans * 0.7;
        this.min = this.info.sort((a, b) => b.fans - a.fans)[this.info.length -1].fans;
        this.current = this.info.sort((a, b) => b.fans - a.fans)[0];
        this.start = (this.info.length - 1) / this.info.sort((a, b) => a.time - b.time).findIndex(((item) => item.time === this.current.time)) * 100
        if(this.start + 20 < 100) {
            this.start =  this.start + 20
        }
    },
    drawChart() {
      echarts.init(document.getElementById("fansadd")).setOption({
        tooltip:{
            show:true,
            trigger: 'axis',
        },
        axiosPointer: {
            type:'shadow',
        },
        dataZoom: [
          {
            type: "inside", //1平移 缩放

            throttle: "40", //设置触发视图刷新的频率。单位为毫秒（ms）。

            minValueSpan: 0, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目

            start:20, //数据窗口范围的起始百分比 范围是：0 ~ 100。表示 0% ~ 100%。

            end: 0, //数据窗口范围的结束百分比。范围是：0 ~ 100。

            zoomLock: true, //如果设置为 true 则锁定选择区域的大小，也就是说，只能平移，不能缩放。
          },
        ],
        grid: {
          left: this.FontChart(-11),
          top: this.FontChart(2),
          bottom: this.FontChart(10),
          right: this.FontChart(-11),
        },
        xAxis: {
          type: "category",
          data: this.data,
          axisLine: {
                  show:false
              },
              axisTick: {
           show: false
       },
        },
        yAxis: {
          name: "人次",
          type: "value",
          min: this.min, // 配置 Y 轴刻度最小值
          max: this.max, // 配置 Y 轴刻度最大值
          splitNumber: this.max, // 配置 Y 轴数值间隔
        },
        series: [
          {
            data: this.fans,
            symbolSize: 0,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                lineStyle: {
                  color: "#FF5000", // 折线颜色设置为0，即只显示点，不显示折线
                },
              },
            },
          },
        ],
      });
    },
  },
  computed: {
    fans() {
        return this.info.sort((a, b) => a.time - b.time).map(item => {
           return item.fans
        })
    },
    data() {
        return this.info.sort((a, b) => a.time - b.time).map(item => {
            const date = new Date(item.time * 1000);
            const m = date.getMonth() + 1;
            const d = date.getDate();
            return `${m}月${d}日`;
        })
    },
    newtime() {
      if (this.current.time) {
        const date = new Date(this.current.time * 1000);
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${m}月${d}日`;
      }
    },
  },
  mounted() {
    if(this.info.length) {
        this.drawChart();
    }
  },
  created() {
    if(this.info.length) {
        this.time();
    }
  }
};
</script>

<style scoped lang="less">
#fansadd {
  width: 100%;
  height: 149px;
}
.box {
  overflow: hidden;
  .box_top {
    width: 100%;
    display: flex;
    justify-content: center;
    .click_top {
      margin: 16px 0;
      width: 150px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-weight: 500;
        font-size: 18px;
        color: #252e39;
      }
      .img {
        height: 100%;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 8px;
          height: 12px;
        }
      }
    }
  }

  .fans {
    display: flex;
    height: 56px;
    align-items: center;
    justify-content: space-evenly;
    .—— {
      width: 1px;
      height: 30px;
      background-color: #e9e9e9;
    }
    .add {
      text-align: center;
      p {
        src: local('Roboto'), local('Roboto-Regular'), url(data:application/octet-stream;charset=utf-8;base64,<YOUR_BASE_64_ENCODED_FILES_SOURCE>) format('woff2');
        unicode-range: U+0460-052F, U+20B4, U+2DE0-2DFF, U+A640-A69F;
        font-size: 20px;
        font-family: 'Roboto';
        color: #000;
        line-height: 39.2px;
      }
      span {
        font-size: 12px;
        color: #8e9aae;
        line-height: 16.8px;
      }
    }
  }
}
</style>
